import { SUBCLUSTERS } from '../subclusters.js';

const CRM_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.LEADS_CAPTURING,
        },
        {
            key: SUBCLUSTERS.SALES_PIPELINE,
        },
        {
            key: SUBCLUSTERS.CONTACT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.MARKETING_ACTIVITIES,
        },
        {
            key: SUBCLUSTERS.LEAD_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.QUOTES_INVOICES,
        },
    ],
    mini_site: {
        logo: {
            url: '/crm',
            alt: 'monday.com CRM and Sales',
            src: 'https://dapulse-res.cloudinary.com/image/upload/CRM-oneliner-box.svg',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/CRM-oneliner-box.svg',
        },
        links: [
            {
                url: '/crm',
                text: 'minisite.header.overview',
            },
            {
                url: '/crm/features',
                text: 'minisite.header.features',
            },
            {
                url: '/crm/whats-new',
                text: 'minisite.header.whatsNew',
            },
            {
                url: 'https://www.crmcare.org/',
                text: 'minisite.header.crmCare',
            },
            {
                url: '/w/crm/partnership',
                text: 'minisite.header.partners',
            },
            {
                url: '/crm/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            url: '/crm',
            alt: 'monday.com CRM and Sales',
            src: 'https://dapulse-res.cloudinary.com/image/upload/CRM-oneliner-box.svg',
        },
    },
    payments_view: {
        pricing: {
            sections: [
                {
                    section: 'ESSENTIALS',
                    overrides: {
                        features: [
                            { feature: 'FILES_MANAGEMENT' },
                            { feature: 'LEAD_ASSIGNMENT' },
                            { feature: 'CUSTOMIZABLE_SALES_PROCESS' },
                            { feature: 'CUSTOMER_PROJECT_MANAGEMENT' },
                            { feature: 'WEB_TO_LEAD_CAPTURING' },
                            { feature: 'CUSTOM_DASHBOARDS' },
                            { feature: 'COLUMN_TYPES' },
                            { feature: 'STORAGE' },
                            { feature: 'ACTIVITY_LOG' },
                        ],
                    },
                },
                {
                    section: 'ADVANCED',
                    overrides: {
                        features: [
                            { feature: 'FORMS' },
                            { feature: 'KANBAN_VIEW' },
                            { feature: 'TWO_WAY_EMAIL_SYNC' },
                            { feature: 'COMMISSION_MANAGEMENT' },
                            { feature: 'ADVANCED_CUSTOMER_PROJECT_MANAGEMENT' },
                            { feature: 'GUESTS' },
                            { feature: 'MAP' },
                            { feature: 'SEARCH' },
                            { feature: 'FORMS_CUSTOMIZATION' },
                            { feature: 'WORKLOAD' },
                            { feature: 'TIME_TRACKING' },
                            { feature: 'CHART_VIEW' },
                            { feature: 'FORMULA' },
                            { feature: 'TAGS' },
                            { feature: 'PRIVATE_BOARDS' },
                            { feature: 'DEPENDENCY_COLUMN' },
                            { feature: 'SALESFORCE_INTEGRATION' },
                            { feature: 'INTEGRATIONS' },
                            { feature: 'AUTOMATIONS' },
                            { feature: 'DASHBOARDS' },
                        ],
                    },
                },
                { section: 'SECURITY_NEW' },
                { section: 'SUPPORT_NEW' },
                { section: 'ADMINISTRATION_AND_CONTROL' },
                { section: 'ADVANCED_REPORTING' },
            ],
            tier_descriptions: {
                pro: 'pricingPage.tierDescriptions.crm.pro',
                free: 'pricingPage.tierDescriptions.crm.free',
                basic: 'pricingPage.tierDescriptions.crm.basic',
                standard: 'pricingPage.tierDescriptions.crm.standard',
                enterprise: 'pricingPage.tierDescriptions.crm.enterprise',
            },
            value_features: {
                pro: [
                    { feature: 'CUSTOMIZED_NOTIFICATIONS' },
                    { feature: 'MARKETING_ACTIVITY_MANAGEMENT' },
                    { feature: 'ADVANCED_PERMISSIONS' },
                    { feature: 'TIME_TRACKING' },
                    { feature: 'WORKFLOW_AND_APPROVAL_AUTOMATION' },
                    { feature: 'ADVANCED_REPORTS' },
                    { feature: 'PRIVATE_BOARDS' },
                    { feature: 'FORMULA' },
                    { feature: 'PRO_AUTOMATIONS' },
                    { feature: 'PRO_INTEGRATIONS' },
                ],
                free: [
                    { feature: 'LEAD_MANAGEMENT' },
                    { feature: 'UNLIMITED_PIPELINES' },
                    { feature: 'UNLIMITED_CONTACTS' },
                    { feature: 'UNLIMITED_CUSTOM_FIELDS' },
                    { feature: 'UNLIMITED_VIEWERS' },
                    { feature: 'FULL_MOBILE_CRM' },
                    { feature: 'DOCUMENT_MANAGEMENT' },
                    { feature: 'API_ACCESS' },
                ],
                basic: [
                    { feature: 'LEAD_MANAGEMENT' },
                    { feature: 'UNLIMITED_PIPELINES' },
                    { feature: 'UNLIMITED_CONTACTS' },
                    { feature: 'UNLIMITED_CUSTOM_FIELDS' },
                    { feature: 'UNLIMITED_VIEWERS' },
                    { feature: 'FULL_MOBILE_CRM' },
                    { feature: 'DOCUMENT_MANAGEMENT' },
                    { feature: 'API_ACCESS' },
                ],
                standard: [
                    { feature: 'TIMELINE' },
                    { feature: 'GUESTS' },
                    { feature: 'EMAIL_INTEGRATION' },
                    { feature: 'SALES_ANALYTICS' },
                    { feature: 'MAILCHIMP_INTEGRATION' },
                    { feature: 'SALES_GOALS' },
                    { feature: 'CALENDAR' },
                    { feature: 'STANDARD_AUTOMATIONS' },
                    { feature: 'STANDARD_INTEGRATIONS' },
                ],
            },
        },
        abTestConfig: {
            homepage: {
                testName: 'homepage_minisite_crm_cluster_ab_test',
                disableTest: 'true',
                forcePricing: 'with_crm_sections',
                syncCookieValue: 'new_with_crm_cluster_data',
                newVariationName: 'new_with_crm_cluster_data',
                sendBigBrainEvent: 'true',
            },
            platform: {
                testName: 'platform_crm_cluster_ab_test',
                newVariationName: 'new_with_crm_cluster_data1',
                sendBigBrainEvent: 'true',
            },
        },
    },
};

export { CRM_CLUSTER };
